import CustomSelect from './CustomSelect';
import CustomRadioGroup from './CustomRadioGroup';

export { 
  CustomRadioGroup,
  CustomSelect,
}


// WEBPACK FOOTER //
// ./src/components/Inputs/index.js